module.exports = __webpack_public_path__ + "static/img/partner.06187e7f.png";